import { render, html } from "lit-html";
import connect from "../../../shared/data-store/connect";
import {
	ACTION_SET_TOGGLE_FILTER,
	ACTION_REMOVE_TOGGLE_FILTER,
	store,
} from "./DataStore";
import { track } from "../../tracker/EventTracker";
import { translate } from "../../../shared/l10n/translate";
import "../../../shared/components/Toggle";
import { data } from "@escapio/shared/state/payload";
import { categoryFilters } from "../../state/hotel-list/get-category-fitlers";

customElements.define(
	"esc-hotel-list-multi-toggle-filter",
	class extends connect(HTMLElement, store) {
		connectedCallback() {
			this.filterName = this.getAttribute("filterName");
			this.defaultFiltersLists = categoryFilters[this.filterName].slice(0, 8);
			this.additionalFiltersLists = categoryFilters[this.filterName].slice(8);
			this.filterTitle = this.isCriteria()
				? translate("filter_dialog_criteria_filter_label")
				: translate("filter_dialog_hotel_type_filter_label");
			this.setFilterAction = this.isCriteria()
				? "Ausstattungsfilter"
				: "Hoteltypenfilter";
			this.toggleFilterAction = this.isCriteria()
				? "Ausstattungsfilter Nutzung"
				: "Hoteltypenfilter Nutzung";
			super.connectedCallback();
		}

		update(state, { counters }) {
			const template = html` <div
					class="expandable-filter__filter-name filter-box__section-title"
				>
					${this.filterTitle}
					<esc-hotel-list-filter-counter
						class="expandable-filter__filter-counter counter-badge counter-badge--green fa--space-before"
						category=${this.filterName}
					>
					</esc-hotel-list-filter-counter>
				</div>
				<div class="expandable-filter">
					<div>
						<div class="expandable-filter__list">
							${this.renderFilterLists(
								this.defaultFiltersLists,
								counters,
								state,
							)}
						</div>

						<div
							class="expandable-filter__list expandable-filter__additional-list"
						>
							${this.renderFilterLists(
								this.additionalFiltersLists,
								counters,
								state,
							)}
						</div>
					</div>
					<esc-toggle
						class="expandable-filter__toggle-button"
						.toggableContainer=${this}
						toggable-selector=".expandable-filter__additional-list"
						@open=${() =>
							track(
								"Filter",
								this.toggleFilterAction,
								`aufklappen${this.trackLabelSuffix}`,
							)}
						@close=${() =>
							track(
								"Filter",
								this.toggleFilterAction,
								`zuklappen${this.trackLabelSuffix}`,
							)}
					>
						<button class="expandable-filter__show-more secondary-button">
							<span
								class="expandable-filter__arrow fa fa-angle-down fa--space-after"
							></span
							><span class="expandable-filter__show-more-text"
								>${translate("filter_show_more")}</span
							><span class="expandable-filter__show-less-text"
								>${translate("filter_show_less")}</span
							>
						</button>
					</esc-toggle>
				</div>`;
			render(template, this, { host: this });
		}

		renderFilterLists(lists, counters, state) {
			return lists.map(({ label, value }) => {
				const hotelCount = counters[this.filterName][value];
				const disabled = hotelCount <= 0 || value == data.preselectedHotelType;
				return html`
					<label class="form-checkbox">
						<input
							class="form-checkbox__input"
							type="checkbox"
							@change=${this.onChange(value)}
							name="${label}"
							?disabled=${disabled}
							.checked=${state.filters[this.filterName].includes(value) ||
							value == data.preselectedHotelType}
						/>
						<span class="form-checkbox__label">
							<span>
								${label}
								<span class="filter-hotel-count">${hotelCount}</span>
							</span>
						</span>
					</label>
				`;
			});
		}

		onChange(value) {
			return event => {
				const { checked, name } = event.target;
				if (checked) {
					this.dispatchAction(ACTION_SET_TOGGLE_FILTER, {
						name: this.filterName,
						value,
					});
					track(
						"Filter",
						this.setFilterAction,
						`${name}${this.trackLabelSuffix}`,
					);
				} else {
					this.dispatchAction(ACTION_REMOVE_TOGGLE_FILTER, {
						name: this.filterName,
						value,
					});
					track(
						"Filter",
						`${this.setFilterAction} entfernen`,
						`${name}${this.trackLabelSuffix}`,
					);
				}
			};
		}

		isCriteria() {
			return this.filterName === "criteria";
		}

		get trackLabelSuffix() {
			return this.getAttribute("track-label-suffix") || "";
		}
	},
);
